__turbopack_context__.v({
  "description": "GuideDescription-module-scss-module__pJrY0G__description",
});
